import React from "react";
import { motion } from "framer-motion";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { GlassCard } from "@/components/common/GlassCard";
import { cn } from "@/lib/utils";

export function KpiCard({ label, value, delta, icon: Icon, accent = "emerald", suffix, index = 0, testId }) {
  const up = (delta ?? 0) >= 0;
  const accentCls =
    accent === "gold"
      ? "text-gold bg-gold/10 border-gold/20"
      : accent === "indigo"
      ? "text-indigo-400 bg-indigo-500/10 border-indigo-500/20"
      : "text-lux-emerald bg-lux-emerald/10 border-lux-emerald/20";

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.07 }}
    >
      <GlassCard hover className="p-6" data-testid={testId}>
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">{label}</p>
            <p className="mt-3 font-heading text-3xl font-semibold tracking-tight text-foreground">
              {value}
              {suffix && <span className="ml-1 text-base font-normal text-muted-foreground">{suffix}</span>}
            </p>
          </div>
          {Icon && (
            <div className={cn("flex h-11 w-11 items-center justify-center rounded-xl border", accentCls)}>
              <Icon className="h-5 w-5" />
            </div>
          )}
        </div>
        {delta !== undefined && delta !== null && (
          <div className="mt-4 flex items-center gap-1.5 text-xs">
            <span
              className={cn(
                "inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 font-semibold",
                up ? "bg-lux-emerald/15 text-lux-emerald" : "bg-destructive/15 text-destructive"
              )}
            >
              {up ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
              {Math.abs(delta)}%
            </span>
            <span className="text-muted-foreground">vs last month</span>
          </div>
        )}
      </GlassCard>
    </motion.div>
  );
}
